const TOAST_DURATION_MS = 2400;

export type NoticeType = 'success' | 'error' | 'warning' | 'info';

export function showTransientNotice(message: string, type: NoticeType = 'success'): void {
    if (typeof document === 'undefined') return;

    let container = document.getElementById('toast-container');
    if (!container) {
        container = document.createElement('div');
        container.id = 'toast-container';
        container.className = 'toast-container';
        document.body.appendChild(container);
    }

    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.textContent = message;
    container.appendChild(toast);

    // Trigger fade-in
    requestAnimationFrame(() => toast.classList.add('visible'));

    // Remove after duration with fade-out
    setTimeout(() => {
        toast.classList.remove('visible');
        setTimeout(() => toast.remove(), 300);
    }, TOAST_DURATION_MS);
}